import { FusaReply } from "@/types/replyTypes";

export enum McpActionStatus {
  PENDING = 'pending',
  EXECUTING = 'executing',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
  REJECTED = 'rejected',
  CANCELLED = 'cancelled',
  EXPIRED = 'expired',
}

/** A changeset is "open" while anything in it still awaits a decision. */
export const MCP_OPEN_ACTION_STATUSES: McpActionStatus[] = [McpActionStatus.PENDING, McpActionStatus.EXECUTING];

export type McpHttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

export interface McpProposedActionParams {
  id: string;
  createdAt: Date | string;
  updatedAt: Date | string;
  changesetId: string;
  sequence: number;
  operationId: string;
  summary: string;
  method: McpHttpMethod;
  path: string;
  pathParams: Record<string, unknown> | null;
  query: Record<string, unknown> | null;
  body: unknown;
  status: McpActionStatus;
  decidedAt: Date | string | null;
  executedAt: Date | string | null;
  responseStatus: number | null;
  response: unknown;
  errorMessage: string | null;
}

export interface McpChangesetParams {
  id: string;
  createdAt: Date | string;
  updatedAt: Date | string;
  title: string;
  propelUserId: string;
  userEmail: string;
  propelOrgId: string;
  actions: McpProposedActionParams[];
}

export interface McpChangesetListResponse extends FusaReply {
  changesets: McpChangesetParams[];
}

export interface McpChangesetResponse extends FusaReply {
  changeset: McpChangesetParams;
}

export interface McpDecideActionsRequest {
  actionIds: string[];
}

export interface McpConnectionInfo {
  /** False when the server has no PropelAuth MCP credentials and is not in dev auth bypass. */
  enabled: boolean;
  serverUrl: string;
  serverName: string;
  /** Ready to paste into a terminal. */
  claudeCodeCommand: string;
  /** True when the server accepts any bearer token (VERIFORM_DEV_AUTH_BYPASS). */
  devAuthBypass: boolean;
}

export interface McpConnectionInfoResponse extends FusaReply {
  connection: McpConnectionInfo;
}
